module.exports = __webpack_public_path__ + "img/prefabs.7c7a5079.gif";